export const CAPACITY_LOAD_UPDATE = 'CAPACITY_LOAD_UPDATE';